import { render } from "./TheButtonSvg.vue?vue&type=template&id=3a8f4de8&scoped=true"
import script from "./TheButtonSvg.vue?vue&type=script&lang=js"
export * from "./TheButtonSvg.vue?vue&type=script&lang=js"

import "./TheButtonSvg.vue?vue&type=style&index=0&id=3a8f4de8&scoped=true&lang=css"

import exportComponent from "/home/emrdev/Project/work/sibugol_dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a8f4de8"]])

export default __exports__